import React from "react";
import Seo from "../Seo/Seo";
import "./LegalPage.scss";

// Set only after the business confirms the effective date for both policies.
export const LEGAL_LAST_UPDATED = null;

function LegalPage({ title, description, path, children }) {
  return (
    <main className="legal-page mobile-type" aria-labelledby="legal-page-title">
      <Seo title={`${title} | Klean Leaf`} description={description} path={path} />
      <article className="legal-page-content">
        <header className="legal-page-header">
          <h1 id="legal-page-title">{title}</h1>
          {LEGAL_LAST_UPDATED && (
            <p className="legal-page-updated">
              Last updated: <time dateTime={LEGAL_LAST_UPDATED.iso}>{LEGAL_LAST_UPDATED.label}</time>
            </p>
          )}
        </header>
        {children}
      </article>
    </main>
  );
}

export default LegalPage;
